/*
See README.md for details
*/

import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { makeCourseNavigationModuleSetSelectorByCoursePath } from '../Courses/CourseNavigation/selectors';

export const modulesSelector = (state) => state.Modules;

export const modulesByCoursePathSelector = createSelector(
  [modulesSelector],
  (modules) => {
    return modules.get('byCoursePath', Immutable.Map());
  }
);

export const makeModulesSelectorByCoursePath = (coursePath) =>
  createSelector(
    [
      makeCourseNavigationModuleSetSelectorByCoursePath(coursePath),
      modulesByCoursePathSelector,
    ],
    (moduleSets, modulesByCoursePath) => {
      const modulesByArray = modulesByCoursePath.get(
        coursePath,
        Immutable.List()
      );
      if (moduleSets.size === 0 || modulesByArray.isEmpty()) {
        return Immutable.List();
      }
      const groupedModulesByNameFromArray = modulesByArray.groupBy(
        (moduleItem) => moduleItem.get('setName')
      );
      const groupedModulesSets = moduleSets.reduce((result, navigation) => {
        const navigationType = navigation.get('type');
        const navigationName = navigation.get('name');
        const isNavigationTypeDefault = navigationType === 'default-module-set';
        let value = null;
        groupedModulesByNameFromArray.forEach((groupedModules, groupedName) => {
          const isNameSame = groupedName === navigationName;
          const isNameNull = groupedName === null;
          const returnedValue = {
            title: navigationName,
            modules: groupedModules,
          };
          /**
           * check navigation type whether is `default-module-set` and `groupedName` is same as `navigationName`
           * - `groupedName` might be null due to `setName`, in this case have to check whether is null or same
           * */
          if (isNavigationTypeDefault && (isNameSame || isNameNull)) {
            value = returnedValue;
            return false;
          } else if (isNameSame) {
            value = returnedValue;
            return false;
          }
          return true;
        });
        return value ? result.push(Immutable.fromJS(value)) : result;
      }, Immutable.List());
      return groupedModulesSets;
    }
  );
